import Cookies from "js-cookie";

function getHost() {
  return (
    import.meta.env.PUBLIC_SA_API_HOST || `${window.location.protocol}//${window.location.host}`
  );
}

export async function getCSRFToken() {
  const HOST = getHost();

  let csrftoken = Cookies.get("csrftoken");
  if (!csrftoken) {
    await fetch(new URL("/platform/connect/", HOST));
    csrftoken = Cookies.get("csrftoken");
  }
  return csrftoken;
}

/**
 * Authenticated fetch using Piano Auth Sync tokens
 * @TODO
 * This should ultimately use Auth0 tokens as the source of truth rather than Piano Auth Sync
 * This will be fixed when useApi() and/or fetchWithAuth is implemented
 *
 * @param {string} authSyncToken Piano Auth Sync token
 * @param {string} auth0EnvSlug Current Auth0 App ID
 * @param {string | URL} inputUrl URL or path to fetch
 * @param {RequestInit} [options] Request options
 */
export async function fetchWithAuthSyncToken(authSyncToken, auth0EnvSlug, inputUrl, options = {}) {
  const HOST = getHost();
  const csrftoken = await getCSRFToken();
  return fetch(new URL(inputUrl, HOST), {
    ...(options || {}),
    headers: {
      ...(options.headers || {}),
      "X-SciAm": "node",
      "X-CSRFToken": csrftoken,

      // see IsValidAuthSyncJWT decorator in Django
      "User-Authorization": `Bearer ${authSyncToken}`,
      "X-Auth-Env": auth0EnvSlug,
    },
  });
}

/**
 * Fetch with builtin CSRF, when you need a POST but no auth.
 *
 * @param {string} inputUrl URL or path to fetch
 * @param {RequestInit} [options]  Request options
 * @returns {Promise}
 */
export async function fetchWithCSRF(inputUrl, options) {
  const HOST = getHost();
  const csrftoken = await getCSRFToken();

  return fetch(new URL(inputUrl, HOST), {
    ...(options || {}),
    headers: {
      ...(options.headers || {}),
      "X-SciAm": "node",
      "X-CSRFToken": csrftoken,
    },
  });
}

export default fetchWithAuthSyncToken;
